module.exports = __webpack_public_path__ + "static/media/118740.e47145b6.svg";